import { buildVersionUrl } from '../../../utils/versionUrl';

const VersionBadge = () => {
  const version = __APP_VERSION__;
  const portal = __PORTAL__;
  const href = buildVersionUrl(version, portal);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Version ${version} - view release notes`}
      title="View what's new"
      className="inline-block text-[12px] text-gray-500 hover:text-[#317690] transition-colors whitespace-nowrap"
    >
      v{version}
    </a>
  );
};

export default VersionBadge;
